// This file is auto-generated by @hey-api/openapi-ts
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { serializeArrayParam, serializeObjectParam, serializePrimitiveParam, } from "./pathSerializer.gen";
export var PATH_PARAM_RE = /\{[^{}]+\}/g;
export var defaultPathSerializer = function (_a) {
    var e_1, _b;
    var path = _a.path, _url = _a.url;
    var url = _url;
    var matches = _url.match(PATH_PARAM_RE);
    if (matches) {
        try {
            for (var matches_1 = __values(matches), matches_1_1 = matches_1.next(); !matches_1_1.done; matches_1_1 = matches_1.next()) {
                var match = matches_1_1.value;
                var explode = false;
                var name = match.substring(1, match.length - 1);
                var style = "simple";
                if (name.endsWith("*")) {
                    explode = true;
                    name = name.substring(0, name.length - 1);
                }
                if (name.startsWith(".")) {
                    name = name.substring(1);
                    style = "label";
                }
                else if (name.startsWith(";")) {
                    name = name.substring(1);
                    style = "matrix";
                }
                var value = path[name];
                if (value === undefined || value === null) {
                    continue;
                }
                if (Array.isArray(value)) {
                    url = url.replace(match, serializeArrayParam({ explode: explode, name: name, style: style, value: value }));
                    continue;
                }
                if (typeof value === "object") {
                    url = url.replace(match, serializeObjectParam({
                        explode: explode,
                        name: name,
                        style: style,
                        value: value,
                        valueOnly: true,
                    }));
                    continue;
                }
                if (style === "matrix") {
                    url = url.replace(match, ";".concat(serializePrimitiveParam({
                        name: name,
                        value: value,
                    })));
                    continue;
                }
                var replaceValue = encodeURIComponent(style === "label" ? ".".concat(value) : value);
                url = url.replace(match, replaceValue);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (matches_1_1 && !matches_1_1.done && (_b = matches_1.return)) _b.call(matches_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return url;
};
export var getUrl = function (_a) {
    var baseUrl = _a.baseUrl, path = _a.path, query = _a.query, querySerializer = _a.querySerializer, _url = _a.url;
    var pathUrl = _url.startsWith("/") ? _url : "/".concat(_url);
    var url = (baseUrl !== null && baseUrl !== void 0 ? baseUrl : "") + pathUrl;
    if (path) {
        url = defaultPathSerializer({ path: path, url: url });
    }
    var search = query ? querySerializer(query) : "";
    if (search.startsWith("?")) {
        search = search.substring(1);
    }
    if (search) {
        url += "?".concat(search);
    }
    return url;
};
export function getValidRequestBody(options) {
    var hasBody = options.body !== undefined;
    var isSerializedBody = hasBody && options.bodySerializer;
    if (isSerializedBody) {
        if ("serializedBody" in options) {
            var hasSerializedBody = options.serializedBody !== undefined && options.serializedBody !== "";
            return hasSerializedBody ? options.serializedBody : null;
        }
        // not all clients implement a serializedBody property (i.e. client-axios)
        return options.body !== "" ? options.body : null;
    }
    // plain/text body
    if (hasBody) {
        return options.body;
    }
    // no body was provided
    return undefined;
}
